/**
 * Vincent #164/#165 — Switcher entre vue Admin/Formateur et vue Apprenant des parcours.
 * Affiche `PathwaysPage` si admin/founder/designer (peut créer/éditer),
 * sinon `LearnerPathwaysView` (progression personnelle).
 */
import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { canEditContent } from "../utils/permissions";
import PathwaysPage from "./PathwaysPage";
import LearnerPathwaysView from "./LearnerPathwaysView";

export default function PathwaysRouter({ pathwayType }) {
  const { user } = useAuth();
  // Vincent #368 (Eric 2026-06-22 SPEC STRICK) → Eric 2026-06-25 (iter117 B2)
  // — migré vers canEditContent (helper canonique). On garde le flag legacy
  // `is_designer` au cas où un seed l'utilise encore.
  const isDesigner = canEditContent(user) || user?.is_designer;

  if (isDesigner) {
    return <PathwaysPage pathwayType={pathwayType} />;
  }
  return <LearnerPathwaysView pathwayType={pathwayType} />;
}
